import { BiFilterAlt, FiDatabase, FiFolder, FiGlobe, FiPlay, FiSkipForward, FiStar, FiStopCircle, LiaCubesSolid, LuClock, MdInput, MdMemory, MdTransform, MdWebhook, RiFileTransferLine, RiLoopRightLine, RiMindMap, RxValueNone, TbZzz, TiFlowSwitch } from '@/components/react-icons/main';
import { TbBracketsContain } from 'react-icons/tb';

const utilityAppIcons = {
  transform: BiFilterAlt,
  map: MdTransform,
  iterate: RiLoopRightLine,
  ifElse: RiMindMap,
  wait: TbZzz,
  continue: FiSkipForward,
  folder: FiFolder,
  ftp: RiFileTransferLine,
  none: RxValueNone,
  webhook: MdWebhook,
  schedule: LuClock,
  functionInputs: MdInput,
  webhookResponse: MdWebhook,
  memory: MdMemory,
  system: FiStar,
  flowControl: TiFlowSwitch,
  httpRequest: FiGlobe,
  runWorkflow: FiPlay,
  function: LiaCubesSolid,
  break: FiStopCircle,
  groupResults: TbBracketsContain,
  keyValueStorage: FiDatabase
};

export default utilityAppIcons;
